export default __webpack_public_path__ + "images/planning-and-ordering.svg";